import type { TemplateFunction, TemplateResult } from 'Components/types';

import EmptyDropdown, { type EmptyDropdownTemplateParams } from './emptyDropdown';
import ListDropdown, { type ListDropdownTemplateParams } from './listDropdown';
import VehicleDropdowns, { type VehicleDropdownsTemplateParams } from './vehicleDropdowns';

interface Props {
  template: TemplateFunction<BaseDropdownTemplateParams>;
  closeGarage: () => void;
  doNotRedirectOnVehicleSelect?: boolean;
  isAutoVehicleSelectionDisabled: boolean;
  isEmpty: boolean;
  isShowVehicleDropdowns: boolean;
  isVehicleSelected: boolean;
  redirectUrl?: string;
  showVehicleDropdowns: () => void;
  useNativeDropdown?: boolean;
  useVehicleWidget?: boolean;
  vehicle: Record<string, string>;
}

export type BaseDropdownTemplateParams =
  | EmptyDropdownTemplateParams
  | ListDropdownTemplateParams
  | VehicleDropdownsTemplateParams;

export default function BaseDropdown({
  template,
  closeGarage,
  doNotRedirectOnVehicleSelect,
  isAutoVehicleSelectionDisabled,
  isEmpty,
  isShowVehicleDropdowns,
  isVehicleSelected,
  redirectUrl,
  showVehicleDropdowns,
  useNativeDropdown,
  useVehicleWidget,
  vehicle,
}: Props): TemplateResult {
  const vehicleWidgetProps = {
    closeGarage,
    doNotRedirectOnVehicleSelect,
    isAutoVehicleSelectionDisabled,
    redirectUrl,
    useNativeDropdown,
  };

  if (isShowVehicleDropdowns) {
    return <VehicleDropdowns {...vehicleWidgetProps} template={template} />;
  }

  if (isEmpty) {
    return (
      <EmptyDropdown
        {...vehicleWidgetProps}
        showVehicleDropdowns={showVehicleDropdowns}
        useVehicleWidget={useVehicleWidget}
        template={template}
      />
    );
  }

  return (
    <ListDropdown
      {...vehicleWidgetProps}
      isVehicleSelected={isVehicleSelected}
      showVehicleDropdowns={showVehicleDropdowns}
      useVehicleWidget={useVehicleWidget}
      vehicle={vehicle}
      template={template}
    />
  );
}
